/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Airline,
    AirlineFromJSON,
    AirlineFromJSONTyped,
    AirlineToJSON,
} from './';

/**
 * 
 * @export
 * @interface AirlineListBusinessDataResponse
 */
export interface AirlineListBusinessDataResponse {
    /**
     * 
     * @type {number}
     * @memberof AirlineListBusinessDataResponse
     */
    watermark?: number;
    /**
     * 
     * @type {Array<Airline>}
     * @memberof AirlineListBusinessDataResponse
     */
    businessData?: Array<Airline> | null;
    /**
     * 
     * @type {number}
     * @memberof AirlineListBusinessDataResponse
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof AirlineListBusinessDataResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof AirlineListBusinessDataResponse
     */
    totalRecords?: number;
}

export function AirlineListBusinessDataResponseFromJSON(json: any): AirlineListBusinessDataResponse {
    return AirlineListBusinessDataResponseFromJSONTyped(json, false);
}

export function AirlineListBusinessDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AirlineListBusinessDataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'watermark': !exists(json, 'watermark') ? undefined : json['watermark'],
        'businessData': !exists(json, 'businessData') ? undefined : (json['businessData'] === null ? null : (json['businessData'] as Array<any>).map(AirlineFromJSON)),
        'pageNumber': !exists(json, 'pageNumber') ? undefined : json['pageNumber'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
    };
}

export function AirlineListBusinessDataResponseToJSON(value?: AirlineListBusinessDataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'watermark': value.watermark,
        'businessData': value.businessData === undefined ? undefined : (value.businessData === null ? null : (value.businessData as Array<any>).map(AirlineToJSON)),
        'pageNumber': value.pageNumber,
        'pageSize': value.pageSize,
        'totalRecords': value.totalRecords,
    };
}


